import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 5;
  box-shadow: 0 2px 16px 0 rgba(${ColorPalette.RGB.Black}, 0.1);
`;

export const Items = styled.ul`
  padding: 0;
  margin: 0;
  max-height: 300px;
  overflow-y: auto;
`;

export const Item = styled.li`
  font-size: 16px;
  cursor: pointer;
  position: relative;
  width: 100%;
`;
export const IconContainer = styled.div`
display: flex;
align-items: center;
  font-size: 16px;
  cursor: pointer;
  color: ${ColorPalette.HEX.OuterSpace};
  border-bottom: 1px solid ${ColorPalette.HEX.BrightGray};
  background: ${ColorPalette.HEX.White};
  position: relative;
  width: 100%;
padding: 1rem;
  &.active {
    background-color: ${ColorPalette.HEX.AntiFlashWhite};
  }

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    background: ${ColorPalette.HEX.FloralYellow};
  }
`;

export const Icon = styled.img`
  height: 100%;
  width: 28px;
  margin-right: 1rem;
`;